import schedules from './schedule.schema';

export default {
  title: 'Harmonogram',
  type: 'object',
  properties: {
    name: {
      title: 'schema.scheduleContainer.name',
      type: 'string',
      fieldRequired: true
    },
    description: {
      title: 'schema.scheduleContainer.description',
      type: 'string',
      fieldRequired: false
    },
    start: {
      title: 'schema.scheduleContainer.start',
      type: 'string',
      format: 'date',
      fieldRequired: true
    },
    end: {
      title: 'schema.scheduleContainer.end',
      type: 'string',
      format: 'date',
      fieldRequired: true,
      minimum: 'this.start'
    },
    entityId: {
      type: 'string',
      fieldRequired: true
    },
    entityType: {
      type: 'string',
      fieldRequired: true
    },
    schedules: {
      type: 'array',
      items: schedules,
      fieldRequired: true
    }
  }
};
